import 'reflect-metadata';
const A = Symbol.for('arg');
export const arg = (...description) => Reflect.metadata(A, description);
export const getArg = (target, property) => {
    const description = Reflect.getMetadata(A, target, property);
    if (!description)
        return;
    const type = Object.getOwnPropertyDescriptor(target, property)?.value?.constructor ??
        Reflect.getMetadata('design:type', target, property);
    return { target, property, description, type };
};
//# sourceMappingURL=arg.js.map